/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/blog-main.js":
/*!*******************************************!*\
  !*** ./src/scripts/sections/blog-main.js ***!
  \*******************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_blog_main_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/blog-main.scss */ \"./src/styles/sections/blog-main.scss\");\n\n\n//=====================================================================================================================\n\nconst assignArticlesListChanger = () => {\n  const blogArticlesBtn = document.querySelector('[data-blog-articles-button]');\n  const blogArticlesList = document.querySelector('[data-blog-articles-list]');\n  window.addEventListener('click', e => {\n    if (e.target == blogArticlesBtn || e.target.closest('[data-blog-articles-button]')) {\n      if (blogArticlesBtn.classList.contains('active')) {\n        blogArticlesBtn.classList.remove('active');\n        blogArticlesList.style.height = '0';\n      } else {\n        blogArticlesBtn.classList.add('active');\n        blogArticlesList.style.height = `${blogArticlesList.scrollHeight}px`;\n      }\n    } else {\n      blogArticlesBtn.classList.remove('active');\n      blogArticlesList.style.height = '0';\n    }\n  });\n};\n\n//=====================================================================================================================\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  assignArticlesListChanger();\n});\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/sections/blog-main.js?\n}");

/***/ }),

/***/ "./src/styles/sections/blog-main.scss":
/*!********************************************!*\
  !*** ./src/styles/sections/blog-main.scss ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/styles/sections/blog-main.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/blog-main.js");
/******/ 	
/******/ })()
;